import { Box } from '@mui/material';
import { useFetchCookies, useRouter } from '@/hooks';
import { DefaultLayout } from '@/layouts';
import { UserProfile } from '@/components/UserManagement/UserProfile';
import { PageLoader } from '@/components/shared/PageLoader';

export const UserProfilePage = () => {
  const router = useRouter();
  const { userid } = router.query;
  const cookiesFetched = useFetchCookies();

  if (!userid || Array.isArray(userid)) {
    return <div>Please specify user userid</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout variant="inspection">
      <UserProfile id={userid} />
    </DefaultLayout>
  );
};
